import type { LiveRoom } from './api';
import { oneliveAssets } from './assets';
import OneliveGnbNavMenu from './OneliveGnbNavMenu';
import ChannelList from './ChannelList';
import { useOneliveLayout } from './OneliveLayoutContext';

interface OneliveSidebarProps {
  rooms: LiveRoom[];
  activeUuid?: string;
}

export default function OneliveSidebar({ rooms, activeUuid }: OneliveSidebarProps) {
  const { sidebarCollapsed, toggleSidebar } = useOneliveLayout();

  return (
    <nav id="onelive-gnb" className={`onelive-gnb${sidebarCollapsed ? ' is-collapsed' : ''}`}>
      <div className="onelive-gnb-head">
        <h2><strong>추천채널</strong></h2>
        <button
          type="button"
          className={`onelive-gnb-toggle${sidebarCollapsed ? ' is-on' : ''}`}
          onClick={toggleSidebar}
          aria-label={sidebarCollapsed ? '사이드바 펼치기' : '사이드바 접기'}
        >
          <img
            src={sidebarCollapsed ? oneliveAssets.sideMenuOn : oneliveAssets.sideMenu}
            alt=""
          />
        </button>
      </div>
      <ChannelList
        rooms={rooms}
        activeUuid={activeUuid}
        showTitle={false}
      />
      <OneliveGnbNavMenu />
    </nav>
  );
}
